import { ArrowRightRegular } from '@fluentui/react-icons'
import { starterPrompts } from '@/data/starterPrompts'
import styles from './SuggestedInvestigations.module.css'

interface SuggestedInvestigationsProps {
  onSelect: (prompt: string) => void
}

export function SuggestedInvestigations({ onSelect }: SuggestedInvestigationsProps) {
  return (
    <div className={styles.grid}>
      {starterPrompts.map((item) => (
        <button
          key={item.id}
          type="button"
          className={styles.card}
          onClick={() => onSelect(item.prompt)}
        >
          <span className={styles.title}>{item.title}</span>
          <ArrowRightRegular className={styles.arrow} aria-hidden="true" />
        </button>
      ))}
    </div>
  )
}
